const concatEid = (eidPrefix, eidSuffix) => [eidPrefix, eidSuffix].filter(str => str).join('.');

export const eidFactory = (eidPrefix) => {
  const eidFactoryInstance = function eidFactoryInstance(eidPart) {
    return concatEid(eidPrefix, eidPart);
  };
  eidFactoryInstance.extend = (eidPart) => eidFactory(concatEid(eidPrefix, eidPart));
  return eidFactoryInstance;
};
